/**
 * Returns `true` if the value is one of the type: `null`, `undefined` or `NaN`.
 *
 * @param {*} value The value to check.
 * @returns {boolean}
 */
export function isNullishOrNaN(value) {
  return value === null || value === undefined || isNaN(value);
}


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/columnSummary/utils.mjs
// module id = 1278
// module chunks = 1